<ng-container *transloco="let t">
  <div
    class="app-header header sticky"
    *ngIf="
      loggedUser && {
        licenses: licenses$ | async
      } as vm
    "
  >
    <!-- Slotted content above header -->
    <ng-content></ng-content>
    <div class="container-fluid main-container">
      <div class="d-flex d-flex">
        <div class="app-sidebar__toggle align-items-center" appSidemenuToggle>
          <a class="open-toggle d-flex align-items-center" href="javascript:;">
            <span class="material-symbols-rounded fs-26"> dehaze </span>
          </a>
        </div>

        <div class="title-wrapper">
          <i class="material-symbols-rounded" (click)="goBack()" *ngIf="helperService.backArrow$ | async"> arrow_back_ios_new </i>
          <div class="title-text">
            <h1>
              {{ title$ | async }}
              <span class="small-text-title" *ngIf="smallTextTitle$ | async as smallTextTitle">({{ smallTextTitle }})</span>
            </h1>
            <span *ngIf="helperService.subtitle$ | async" class="subtitle">{{ helperService.subtitle$ | async }}</span>
          </div>
        </div>

        <div class="d-flex order-lg-2 ms-auto align-self-start">
          <div class="mb-0 navbar navbar-expand-lg navbar-nav-right responsive-navbar navbar-dark p-0">
            <div class="navbar-collapse" id="navbarSupportedContent-4">
              <div class="d-flex ms-auto gap-2 gap-lg-3">
                <!-- <app-language-picker></app-language-picker> -->

                <button *ngIf="enableStartQuestionnaireButton" (click)="startQuestionnaire()" class="add-task btn btn-primary mr-4">
                  <span class="material-symbols-rounded"> play_arrow </span>
                  <span class="d-lg-block d-none">
                    {{ t('child/addChild') }}
                  </span>
                </button>

                <app-workplace-info *ngIf="isDirector"></app-workplace-info>

                <div class="dropdown header-flags" ngbDropdown>
                  <button
                    type="button"
                    id="manager-menu-profile"
                    class="btn nav-link py-0 px-0 border-0 d-flex gap-lg-3 gap-1 align-items-center"
                    ngbDropdownToggle
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="material-symbols-rounded text-primary"> account_circle </span>
                    <span class="d-lg-block d-none">
                      {{ username }}
                    </span>
                    <span class="material-symbols-rounded arrow"> keyboard_arrow_down </span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="manager-menu-profile">
                    <!--                    <div class="dropdown-item disabled">{{ username }}</div>-->
                    <!--                    <hr />-->
                    <a class="dropdown-item" data-cy-test="Změna hesla" [routerLink]="routerLinkFactory.changePassword()">{{
                      t('user/passwordChange')
                    }}</a>
                    <button class="dropdown-item" (click)="onLogout()">{{ t('shared/logOut') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
